
/**
 * 추가 메타데이터
 */
export type CreateSubscriptionSessionRequestMetadata = { [key: string]: unknown };
